import { IS_IOS } from '@weblite/logic-toolkit'
import { IS_SAFARI } from '$func/environmentInfo'

export interface OnboardingAction {
  action: string
  time: string
}

export enum IosSafariOnboarding {
  IOS_SYNC_CONTACTS = 'iOSSyncContacts',
}

export enum CommonOnboarding {}

export type IOnboarding = IosSafariOnboarding | CommonOnboarding

export interface ActionsState {
  actions: Set<string>
  fetched: boolean
}

export const onboardingActions = [
  ...Object.values(CommonOnboarding || {}),
  ...(IS_IOS && IS_SAFARI ? Object.values(IosSafariOnboarding) : []),
]
